import { HttpClient } from "@angular/common/http";
import { ChangeDetectorRef, Component, OnInit, AfterViewInit, OnDestroy, ViewChild, TemplateRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import Api from "app/helpers/api";
import App from "app/helpers/app";
import Me from "app/helpers/me";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { take } from "rxjs/operators";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import * as Papa from "papaparse";
import { saveAs } from "file-saver";
import { BreadcrumbService } from '../shared/services/breadcrumb.service';
import { NgbModal, NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

interface FiltrosImportacao {
  dataInicio?: string;
  dataFim?: string;
}

interface FiltrosFlaxFlow {
  nomeServidor?: string;
  cpf?: string;
}

interface ProgressoImportacao {
  ativo: boolean;
  percentual: number;
  linhasProcessadas: number;
  totalLinhas: number;
  mensagem: string;
  tipoImportacao: string;
}

@Component({
  selector: "importacoes-component",
  templateUrl: "./importacoes.component.html",
  styleUrls: ["./importacoes.component.scss"],
})
export class ImportacoesComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('uploadSimplificadoModal') uploadSimplificadoModal!: TemplateRef<any>;
  @ViewChild('uploadIdadeAposentadoriaModal') uploadIdadeAposentadoriaModal!: TemplateRef<any>;
  @ViewChild('uploadGeralModal') uploadGeralModal!: TemplateRef<any>;
  @ViewChild('uploadMovimentacaoModal') uploadMovimentacaoModal!: TemplateRef<any>;
  @ViewChild('uploadServidoresCensoModal') uploadServidoresCensoModal!: TemplateRef<any>;
  @ViewChild('uploadFlaxFlowModal') uploadFlaxFlowModal!: TemplateRef<any>;
  @ViewChild('uploadSalarioBaseModal') uploadSalarioBaseModal!: TemplateRef<any>;
  @ViewChild('logSalarioBaseModal') logSalarioBaseModal!: TemplateRef<any>;
  @ViewChild('naoImportadosModal') naoImportadosModal!: TemplateRef<any>;

  idCidade;
  cidade = null;
  nomeCidade: string;
  isAdmin = false;
  planilhas = [];
  listaSimplificado = [];
  listaUploadServidores = []
  listaUploadAposentados = []
  listaUploadPensionistas = []
  listaUploadIdadeAposentadoria = []
  listaImportacaoMensal = []
  listaUploadServidoresCenso = []
  listaFlaxFlow = []
  listaSalarioBase = []

  // Listas originais para filtros
  listaSimplificadoOriginal = [];
  listaUploadServidoresOriginal = [];
  listaUploadAposentadosOriginal = [];
  listaUploadPensionistasOriginal = [];
  listaUploadIdadeAposentadoriaOriginal = [];
  listaImportacaoMensalOriginal = [];
  listaUploadServidoresCensoOriginal = [];
  listaFlaxFlowOriginal = [];
  listaSalarioBaseOriginal = [];

  // Variáveis de paginação
  currentPageSimplificado = 1;
  currentPageServidores = 1;
  currentPageAposentados = 1;
  currentPagePensionistas = 1;
  currentPageIdadeAposentadoria = 1;
  currentPageMensal = 1;
  currentPageServidoresCenso = 1;
  currentPageFlaxFlow = 1;
  currentPageSalarioBase = 1;

  itemsPorPaginaSimplificado = 10;
  itemsPorPaginaServidores = 10;
  itemsPorPaginaAposentados = 10;
  itemsPorPaginaPensionistas = 10;
  itemsPorPaginaIdadeAposentadoria = 10;
  itemsPorPaginaMensal = 10;
  itemsPorPaginaServidoresCenso = 10;
  itemsPorPaginaFlaxFlow = 10;
  itemsPorPaginaSalarioBase = 10;

  // Controle global de itens por página
  itemsPorPaginaGlobal = 10;

  // Variáveis para paginação FlaxFlow (API)
  flaxFlowPagination = {
    total: 0,
    offset: 0,
    limit: 10,
    hasMore: false
  };

  // Variável para controle de loading FlaxFlow
  flaxFlowLoading = false;

  // Variáveis para upload FlaxFlow
  anexoFlaxFlow = {
    arquivos: [],
    opcao: "processarEAnexar"
  };
  statusEnvioFlaxFlow: string = '';

  // Variáveis para Salário Base
  logSalarioBase: any = null;
  salarioBaseLoading = false;
  pollingIntervalSalarioBase: any = null;

  // Dados exibidos na modal de registros rejeitados pelo importador do censo.

  importacaoSelecionada: any = null;
  itensNaoImportados: string[] = [];

  // Variáveis de ordenação para cada tab
  sortColumns = {
    simplificado: '',
    servidores: '',
    aposentados: '',
    pensionistas: '',
    idadeAposentadoria: '',
    mensal: '',
    servidoresCenso: '',
    flaxFlow: 'data_envio',
    salarioBase: ''
  };

  sortDirections = {
    simplificado: 'asc',
    servidores: 'asc',
    aposentados: 'asc',
    pensionistas: 'asc',
    idadeAposentadoria: 'asc',
    mensal: 'asc',
    servidoresCenso: 'asc',
    flaxFlow: 'DESC',
    salarioBase: 'asc'
  };

  // Variáveis para filtros
  filters: FiltrosImportacao = {
    dataInicio: null,
    dataFim: null
  };

  // Variáveis para filtros FlaxFlow
  filtrosFlaxFlow: FiltrosFlaxFlow = {
    nomeServidor: null,
    cpf: null
  };

  // Variáveis para controle das modais
  uploadData = {
    file: null,
    month: '',
    year: '',
    loading: false,
    errors: {
      file: '',
      month: '',
      year: ''
    }
  };

  // Variável para controle do tipo de upload atual
  currentUploadType: number = 0;
  currentUploadTitle: string = '';
  currentUploadDescription: string = '';

  // Variável para controlar se a tab FlaxFlow foi ativada
  flaxFlowTabActivated: boolean = false;

  // Variáveis para controle de progresso
  progressoImportacao: ProgressoImportacao = {
    ativo: false,
    percentual: 0,
    linhasProcessadas: 0,
    totalLinhas: 0,
    mensagem: '',
    tipoImportacao: ''
  };

  // Variáveis para polling
  private pollingInterval: any;
  private readonly POLLING_INTERVAL = 5000; // 5 segundos

  apiCall = this.api.new().silent();
  meses = [
    { id: 1, nome: "Janeiro" },
    { id: 2, nome: "Fevereiro" },
    { id: 3, nome: "Março" },
    { id: 4, nome: "Abril" },
    { id: 5, nome: "Maio" },
    { id: 6, nome: "Junho" },
    { id: 7, nome: "Julho" },
    { id: 8, nome: "Agosto" },
    { id: 9, nome: "Setembro" },
    { id: 10, nome: "Outubro" },
    { id: 11, nome: "Novembro" },
    { id: 12, nome: "Dezembro" },
  ];
  anos = [
    { id: 2020, nome: "2020" },
    { id: 2021, nome: "2021" },
    { id: 2022, nome: "2022" },
    { id: 2023, nome: "2023" },
    { id: 2024, nome: "2024" },
    { id: 2025, nome: "2025" },
    { id: 2026, nome: "2026" },
    { id: 2027, nome: "2027" },
  ];
  mesUpload = null;
  anoUpload = null;
  jobs = [];

  colunasEsperadasInativos = [
    "NU_ANO",
    "CO_IBGE",
    "NO_ENTE",
    "SG_UF",
    "CO_COMP_MASSA",
    "CO_TIPO_FUNDO",
    "CNPJ_ORGAO",
    "NO_ORGAO",
    "CO_PODER",
    "CO_TIPO_PODER",
    "CO_TIPO_POPULACAO",
    "CO_TIPO_CARGO",
    "CO_TIPO_APOSENTADORIA",
    "ID_APOSENTADO_MATRICULA",
    "ID_APOSENTADO_CPF",
    "ID_APOSENT_PIS_PASEP",
    "CO_SEXO_APOSENTADO",
    "CO_EST_CIVIL_APOSENTADO",
    "DT_NASC_APOSENTADO",
    "DT_INICIO_APOSENTADORIA",
    "VL_APOSENTADORIA",
    "VL_CONTRIBUICAO",
    "IN_PARID_SERV",
    "CO_CONDICAO_APOSENTADO",
    "VL_COMPENS_PREVID",
    "NU_DEPENDENTES",
    "DT_NASC_CONJUGE",
    "CO_CONDICAO_CONJUGE",
    "DT_NASC_DEPENDENTE_1",
    "CO_CONDICAO_DEPENDENTE_1",
    "DT_NASC_DEPENDENTE_2",
    "CO_CONDICAO_DEPENDENTE_2",
  ];

  colunasEsperadasAposentados = [
    "NU_ANO",
    "CO_IBGE",
    "NO_ENTE",
    "SG_UF",
    "CO_COMP_MASSA",
    "CO_TIPO_FUNDO",
    "CNPJ_ORGAO",
    "NO_ORGAO",
    "CO_PODER",
    "CO_TIPO_PODER",
    "CO_TIPO_INSTITUIDOR",
    "ID_INSTITUIDOR_MATRICULA",
    "ID_INSTITUIDOR_CPF",
    "ID_INSTITUIDOR_PIS_PASEP",
    "ID_PENSIONISTA_CPF",
    "CO_SEXO_PENSIONISTA",
    "DT_NASC_PENSIONISTA",
    "DT_INICIO_PENSAO",
    "VL_BENEF_PENSAO",
    "VL_CONTRIBUICAO",
    "VL_COMPENS_PREVID",
    "IN_PARID_SERV",
    "CO_CONDICAO",
    "CO_DURACAO",
  ];
  colunasEsperadasSimplificado = [
    "CO_IBGE",
    "ID_SERVIDOR_MATRICULA",
    "ID_SERVIDOR_CPF",
    "STATUS_SERVIDOR",
    "NOME_SERVIDOR",
  ];
  colunasEsperadasIdadeAposentadoria = [
    "CO_IBGE",
    "SERVIDOR_MATRICULA",
    "SERVIDOR_IDADE",
  ];
  colunasEsperadasAtivos = [
    "NU_ANO",
    "CO_IBGE",
    "NO_ENTE",
    "SG_UF",
    "CO_COMP_MASSA",
    "CO_TIPO_FUNDO",
    "NU_CNPJ_ORGAO",
    "NO_ORGAO",
    "CO_PODER",
    "CO_TIPO_PODER",
    "CO_TIPO_POPULACAO",
    "CO_TIPO_CARGO",
    "CO_CRITERIO_ELEGIBILIDADE",
    "ID_SERVIDOR_MATRICULA",
    "ID_SERVIDOR_CPF",
    "ID_SERVIDOR_PIS_PASEP",
    "CO_SEXO_SERVIDOR",
    "CO_EST_CIVIL_SERVIDOR",
    "DT_NASC_SERVIDOR",
    "CO_SITUACAO_FUNCIONAL",
    "CO_TIPO_VINCULO",
    "DT_ING_SERV_PUB",
    "DT_ING_ENTE",
    "DT_ING_CARREIRA",
    "NO_CARREIRA",
    "DT_ING_CARGO",
    "NO_CARGO",
    "VL_BASE_CALCULO",
    "VL_REMUNERACAO",
    "NU_TEMPO_RGPS",
    "NU_TEMPO_RPPS",
    "NU_DEPENDENTES",
    "DT_NASC_CONJUGE",
    "CO_COND_CONJUGE",
    "DT_NASC_DEPENDENTE_1",
    "CO_COND_DEPENDENTE_1",
    "DT_NASC_DEPENDENTE_2",
    "CO_COND_DEPENDENTE_2",
    "IN_ABONO_PERMANENCIA",
    "DT_INICIO_ABONO",
    "DT_PROV_APOSENT",
  ];

  // Colunas esperadas para importação de servidores censo
  colunasEsperadasServidoresCenso = [
    "CPF",
    "RG",
    "PIS",
    "Matrícula",
    "Nome Completo",
    "Status",
    "Sexo",
    "Data Nascimento",
    "Estado Civil",
    "Nome da Mãe",
    "Nome do Pai",
    "Nacionalidade",
    "Naturalizado",
    "Estado Naturalidade",
    "Cidade Naturalidade",
    "Escolaridade",
    "PCD",
    "CEP",
    "Tipo Logradouro",
    "Estado",
    "Cidade",
    "Logradouro",
    "Número",
    "Bairro",
    "Complemento",
    "Telefone",
    "Celular",
    "Email",
    "Cargo",
    "Secretaria"
  ];

  // Colunas esperadas para importação de salário base
  colunasEsperadasSalarioBase = [
    "NOME",
    "CPF",
    "MATRICULA",
    "SALARIO",
    "STATUS (OPCIONAL)"
  ];

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private me: Me,
    private api: Api,
    private app: App,
    private route: ActivatedRoute,
    private http: HttpClient,
    private breadcrumbService: BreadcrumbService,
    private modalService: NgbModal,
    private router: Router
  ) {
    // Inicializar todas as listas para evitar problemas de undefined
    this.listaSimplificado = [];
    this.listaUploadServidores = [];
    this.listaUploadAposentados = [];
    this.listaUploadPensionistas = [];
    this.listaUploadIdadeAposentadoria = [];
    this.listaImportacaoMensal = [];
    this.listaUploadServidoresCenso = [];
    this.listaFlaxFlow = [];
    this.listaSalarioBase = [];

    this.listaSimplificadoOriginal = [];
    this.listaUploadServidoresOriginal = [];
    this.listaUploadAposentadosOriginal = [];
    this.listaUploadPensionistasOriginal = [];
    this.listaUploadIdadeAposentadoriaOriginal = [];
    this.listaImportacaoMensalOriginal = [];
    this.listaUploadServidoresCensoOriginal = [];
    this.listaFlaxFlowOriginal = [];
    this.listaSalarioBaseOriginal = [];
  }

  async ngOnInit() {
    const self = this;

    try {
      // Primeiro, obter parâmetros da rota se existirem
      const parametros = await self.route.queryParams.pipe(take(1)).toPromise();
      if (parametros && parametros["idCidade"]) {
        self.idCidade = parametros["idCidade"];
        console.log('ID Cidade obtido dos parâmetros:', self.idCidade);
      }

      const dadosUsuario = self.me.currentUserValue;
      const json = JSON.parse(JSON.stringify(dadosUsuario));
      const cidade = json.user.cidade;

      self.isAdmin = json.user.tipo === "1";
      
      // Configurar breadcrumbs como componente filho - SEMPRE 3 níveis
      if (self.idCidade) {
        self.breadcrumbService.setMunicipioBreadcrumbs('Importações', Number(self.idCidade));
      } else {
        self.breadcrumbService.setMunicipioBreadcrumbs('Importações');
      }
      
      // Se não tem idCidade dos parâmetros, usar a cidade do usuário
      if (!self.idCidade && cidade) {
        self.idCidade = cidade;
        console.log('ID Cidade obtido do usuário:', self.idCidade);
      }

      // Para admins, verificar novamente os parâmetros da rota
      if (json.user.tipo === "1") {
        console.log("caiu if");
        if (parametros && parametros["idCidade"]) {
          let idCidade = parametros["idCidade"];
          self.idCidade = idCidade;
          json.user.cidade = idCidade;
          self.me.atualizaCidade(json);
          console.log('ID Cidade atualizado para admin:', self.idCidade);
        }
      }

      // Garantir que temos um idCidade antes de fazer a requisição
      if (self.idCidade) {
        console.log('Carregando planilhas para cidade:', self.idCidade);
        
        // Garantir que os filtros FlaxFlow estejam limpos no carregamento inicial
        self.filtrosFlaxFlow = {
          nomeServidor: null,
          cpf: null
        };
        
        // Carregar dados FlaxFlow
        await self.carregarDadosFlaxFlow();
        
        const planilhas = await self.apiCall
          .get("servidor/arquivo/planilha?id_cidade=" + self.idCidade)
          .pipe(take(1))
          .toPromise();

        console.log('Resposta da API:', planilhas);

        if (planilhas && planilhas.length > 0) {
          console.log("planilhas", planilhas);
          
          // Filtrando as listas com base no valor de 'type'
          this.listaSimplificado = planilhas.filter(item => item.type === 9);
          this.listaUploadServidores = planilhas.filter(item => item.type === 1);
          this.listaUploadAposentados = planilhas.filter(item => item.type === 2);
          this.listaUploadPensionistas = planilhas.filter(item => item.type === 3);
          this.listaUploadIdadeAposentadoria = planilhas.filter(item => item.type === 8);
          this.listaImportacaoMensal = planilhas.filter(item => item.type === 77);
          this.listaUploadServidoresCenso = planilhas.filter(item => item.type === 99);
          this.listaSalarioBase = planilhas.filter(item => item.type === 100);

          // Logs para debug
          console.log('Lista Simplificado carregada:', this.listaSimplificado.length, 'itens');
          console.log('Lista Servidores carregada:', this.listaUploadServidores.length, 'itens');
          console.log('Lista Aposentados carregada:', this.listaUploadAposentados.length, 'itens');
          console.log('Lista Pensionistas carregada:', this.listaUploadPensionistas.length, 'itens');
          console.log('Lista Idade Aposentadoria carregada:', this.listaUploadIdadeAposentadoria.length, 'itens');
          console.log('Lista Mensal carregada:', this.listaImportacaoMensal.length, 'itens');
          console.log('Lista Servidores Censo carregada:', this.listaUploadServidoresCenso.length, 'itens');
          console.log('Lista Salário Base carregada:', this.listaSalarioBase.length, 'itens');

          // Salvar listas originais para filtros
          this.listaSimplificadoOriginal = [...this.listaSimplificado];
          this.listaUploadServidoresOriginal = [...this.listaUploadServidores];
          this.listaUploadAposentadosOriginal = [...this.listaUploadAposentados];
          this.listaUploadPensionistasOriginal = [...this.listaUploadPensionistas];
          this.listaUploadIdadeAposentadoriaOriginal = [...this.listaUploadIdadeAposentadoria];
          this.listaImportacaoMensalOriginal = [...this.listaImportacaoMensal];
          this.listaUploadServidoresCensoOriginal = [...this.listaUploadServidoresCenso];
          this.listaFlaxFlowOriginal = [...this.listaFlaxFlow];
          this.listaSalarioBaseOriginal = [...this.listaSalarioBase];

          // Forçar detecção de mudanças para atualizar a view
          this.changeDetectorRef.detectChanges();
          console.log('Detecção de mudanças executada');

          // Iniciar polling se houver importações em andamento
          if (this.hasImportingJobs()) {
            this.startPolling();
          }
          
          // Iniciar polling se houver planilhas de salário base em andamento
          if (this.hasPendingSalarioBase()) {
            this.startPollingSalarioBase();
          }
        } else {
          console.log('Nenhuma planilha encontrada ou resposta vazia');
          // Inicializar listas vazias para evitar erros de template
          // NÃO resetar listaFlaxFlow pois ela já foi carregada separadamente
          this.listaSimplificado = [];
          this.listaUploadServidores = [];
          this.listaUploadAposentados = [];
          this.listaUploadPensionistas = [];
          this.listaUploadIdadeAposentadoria = [];
          this.listaImportacaoMensal = [];
          this.listaUploadServidoresCenso = [];
          // this.listaFlaxFlow = []; // NÃO resetar - já foi carregada
          
          this.listaSimplificadoOriginal = [];
          this.listaUploadServidoresOriginal = [];
          this.listaUploadAposentadosOriginal = [];
          this.listaUploadPensionistasOriginal = [];
          this.listaUploadIdadeAposentadoriaOriginal = [];
          this.listaImportacaoMensalOriginal = [];
          this.listaUploadServidoresCensoOriginal = [];
          // this.listaFlaxFlowOriginal = []; // NÃO resetar - já foi carregada
          
          this.changeDetectorRef.detectChanges();
        }
      } else {
        console.warn('ID da cidade não encontrado');
        // Inicializar listas vazias
        // NÃO resetar listaFlaxFlow se ela já foi carregada
        this.listaSimplificado = [];
        this.listaUploadServidores = [];
        this.listaUploadAposentados = [];
        this.listaUploadPensionistas = [];
        this.listaUploadIdadeAposentadoria = [];
        this.listaImportacaoMensal = [];
        this.listaUploadServidoresCenso = [];
        // this.listaFlaxFlow = []; // NÃO resetar se já foi carregada
        
        this.listaSimplificadoOriginal = [];
        this.listaUploadServidoresOriginal = [];
        this.listaUploadAposentadosOriginal = [];
        this.listaUploadPensionistasOriginal = [];
        this.listaUploadIdadeAposentadoriaOriginal = [];
        this.listaImportacaoMensalOriginal = [];
        this.listaUploadServidoresCensoOriginal = [];
        // this.listaFlaxFlowOriginal = []; // NÃO resetar se já foi carregada
        
        this.changeDetectorRef.detectChanges();
      }
    } catch (error) {
      console.error('Erro no ngOnInit:', error);
      // Inicializar listas vazias em caso de erro
      // NÃO resetar listaFlaxFlow se ela já foi carregada
      this.listaSimplificado = [];
      this.listaUploadServidores = [];
      this.listaUploadAposentados = [];
      this.listaUploadPensionistas = [];
      this.listaUploadIdadeAposentadoria = [];
      this.listaImportacaoMensal = [];
      this.listaUploadServidoresCenso = [];
      // this.listaFlaxFlow = []; // NÃO resetar se já foi carregada
      
      this.listaSimplificadoOriginal = [];
      this.listaUploadServidoresOriginal = [];
      this.listaUploadAposentadosOriginal = [];
      this.listaUploadPensionistasOriginal = [];
      this.listaUploadIdadeAposentadoriaOriginal = [];
      this.listaImportacaoMensalOriginal = [];
      this.listaUploadServidoresCensoOriginal = [];
      // this.listaFlaxFlowOriginal = []; // NÃO resetar se já foi carregada
      
      this.changeDetectorRef.detectChanges();
    }
  }

  ngAfterViewInit() {
    // Forçar uma detecção de mudanças adicional após a view ser inicializada
    // Usar setTimeout para garantir que isso aconteça após todas as operações assíncronas
    setTimeout(() => {
      console.log('ngAfterViewInit - Executando detecção de mudanças');
      console.log('Status das listas:', {
        simplificado: this.listaSimplificado?.length || 0,
        servidores: this.listaUploadServidores?.length || 0,
        aposentados: this.listaUploadAposentados?.length || 0,
        pensionistas: this.listaUploadPensionistas?.length || 0,
        idadeAposentadoria: this.listaUploadIdadeAposentadoria?.length || 0,
        mensal: this.listaImportacaoMensal?.length || 0,
        servidoresCenso: this.listaUploadServidoresCenso?.length || 0
      });
      
      this.changeDetectorRef.markForCheck();
      this.changeDetectorRef.detectChanges();
    }, 200);
  }

  ngOnDestroy() {
    // Limpar polling quando o componente for destruído
    this.stopPolling();
    this.stopPollingSalarioBase();
  }

  // Método removido - funcionalidade migrada para modais

  fileNameAndExt(str) {
    var file = str.split("/").pop();
    return [
      file.substr(0, file.lastIndexOf(".")),
      file.substr(file.lastIndexOf(".") + 1, file.length),
    ];
  }

  async novoUploadMovimentacao() {
    this.openUploadMovimentacaoModal(this.uploadMovimentacaoModal);
  }

  csvJSON(csv) {
    var lines = csv.split("\r\n");
    var result = [];

    // NOTE: If your columns contain commas in their values, you'll need
    // to deal with those before doing the next step
    // (you might convert them to &&& or something, then covert them back later)
    // jsfiddle showing the issue https://jsfiddle.net/
    var headers = lines[0].split(";");
    for (var i = 1; i < lines.length; i++) {
      var obj = {};
      var currentline = lines[i].split(";");
      if (currentline.length > 1) {
        for (var j = 0; j < headers.length; j++) {
          obj[headers[j]] = currentline[j];
        }
        result.push(obj);
      }
    }

    //return result; //JavaScript object
    return JSON.stringify(result); //JSON
  }

  formatarData(data: string): string {
    if (!data) return '---';
    const date = new Date(data);
    return `${date.getDate().toString().padStart(2, "0")}/${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
  }

  formatarDataHora(data: string): string {
    if (!data) return '---';
    const date = new Date(data);
    const dia = date.getDate().toString().padStart(2, "0");
    const mes = (date.getMonth() + 1).toString().padStart(2, "0");
    const ano = date.getFullYear();
    const hora = date.getHours().toString().padStart(2, "0");
    const minuto = date.getMinutes().toString().padStart(2, "0");
    const segundo = date.getSeconds().toString().padStart(2, "0");
    return `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`;
  }

  formatarDataCurta(data: string): string {
    if (!data) return '---';
    const date = new Date(data);
    const dia = date.getDate().toString().padStart(2, "0");
    const mes = (date.getMonth() + 1).toString().padStart(2, "0");
    const ano = date.getFullYear().toString().slice(-2); // Últimos 2 dígitos do ano
    return `${dia}/${mes}/${ano}`;
  }

  formatarHora(data: string): string {
    if (!data) return '---';
    const date = new Date(data);
    const hora = date.getHours().toString().padStart(2, "0");
    const minuto = date.getMinutes().toString().padStart(2, "0");
    const segundo = date.getSeconds().toString().padStart(2, "0");
    return `${hora}:${minuto}:${segundo}`;
  }

  formatarTamanho(tamanho: number): string {
    if (!tamanho) return '---';
    return tamanho.toString();
  }

  formatarCompetencia(data: string): string {
    const date = new Date(data);
    return `${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
  }

  traduzirStatus(status: number): string {
    switch (status) {
      case 0:
        return "na fila";
      case 1:
        return "processando";
      case 2:
        return "processado";
      case 3:
        return "erro";
      default:
        return "desconhecido";
    }
  }
  getItensNaoImportados(invalidCpfs: any): string[] {
    if (!invalidCpfs) return [];

    if (Array.isArray(invalidCpfs)) {
      return invalidCpfs
        .map(item => String(item).trim())
        .filter(item => item.length > 0);
    }

    if (typeof invalidCpfs === "string") {
      const valor = invalidCpfs.trim();
      if (!valor) return [];

      try {
        const convertido = JSON.parse(valor);
        if (Array.isArray(convertido)) {
          return convertido
            .map(item => String(item).trim())
            .filter(item => item.length > 0);
        }
      } catch (_) {
        // O backend também persiste a lista separada por ponto e vírgula.

      }

      return valor
        .split(/\s*;\s*/)
        .map(item => item.trim())
        .filter(item => item.length > 0);
    }

    return [String(invalidCpfs)];
  }

  abrirNaoImportados(importacao: any): void {
    this.importacaoSelecionada = importacao;
    this.itensNaoImportados = this.getItensNaoImportados(importacao.invalid_cpfs);
    this.modalService.open(this.naoImportadosModal, {
      centered: true,
      size: 'lg',
      scrollable: true
    });
  }

  downloadInvalidCpfs(invalidCpfs: any): void {
    const cpfArray = this.getItensNaoImportados(invalidCpfs);

    if (cpfArray.length > 0) {
      const csvData = Papa.unparse(cpfArray.map((item) => ({ "Registro não importado": item })));
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "registros_nao_importados.csv");
    } else {
      console.error("invalidCpfs não é um array ou está vazio");
    }
  }
  async uploadSimplificado() {
    this.openUploadSimplificadoModal(this.uploadSimplificadoModal);
  }

  async uploadIdadeAposentadoria() {
    this.openUploadIdadeAposentadoriaModal(this.uploadIdadeAposentadoriaModal);
  }

  async uploadServidoresCenso() {
    this.openUploadServidoresCensoModal(this.uploadServidoresCensoModal);
  }

  async selecionaArquivo(type: number) {
    this.openUploadGeralModal(this.uploadGeralModal, type);
  }

  // Método antigo removido - agora usa processarUploadArquivo

  // Métodos de filtros
  aplicarFiltros() {
    console.log('Aplicando filtros:', this.filters);
    
    // Restaurar listas originais
    this.listaSimplificado = [...this.listaSimplificadoOriginal];
    this.listaUploadServidores = [...this.listaUploadServidoresOriginal];
    this.listaUploadAposentados = [...this.listaUploadAposentadosOriginal];
    this.listaUploadPensionistas = [...this.listaUploadPensionistasOriginal];
    this.listaUploadIdadeAposentadoria = [...this.listaUploadIdadeAposentadoriaOriginal];
    this.listaImportacaoMensal = [...this.listaImportacaoMensalOriginal];
    this.listaUploadServidoresCenso = [...this.listaUploadServidoresCensoOriginal];
    this.listaSalarioBase = [...this.listaSalarioBaseOriginal];

    // Aplicar filtros de data
    if (this.filters.dataInicio || this.filters.dataFim) {
      this.listaSimplificado = this.filtrarPorData(this.listaSimplificado);
      this.listaUploadServidores = this.filtrarPorData(this.listaUploadServidores);
      this.listaUploadAposentados = this.filtrarPorData(this.listaUploadAposentados);
      this.listaUploadPensionistas = this.filtrarPorData(this.listaUploadPensionistas);
      this.listaUploadIdadeAposentadoria = this.filtrarPorData(this.listaUploadIdadeAposentadoria);
      this.listaImportacaoMensal = this.filtrarPorData(this.listaImportacaoMensal);
      this.listaUploadServidoresCenso = this.filtrarPorData(this.listaUploadServidoresCenso);
      this.listaFlaxFlow = this.filtrarPorDataFlaxFlow(this.listaFlaxFlow);
      this.listaSalarioBase = this.filtrarPorData(this.listaSalarioBase);
    }

    // Resetar páginas para primeira página
    this.currentPageSimplificado = 1;
    this.currentPageServidores = 1;
    this.currentPageAposentados = 1;
    this.currentPagePensionistas = 1;
    this.currentPageIdadeAposentadoria = 1;
    this.currentPageMensal = 1;
    this.currentPageServidoresCenso = 1;
    this.currentPageFlaxFlow = 1;
    this.currentPageSalarioBase = 1;
  }

  limparFiltros() {
    this.filters = {
      dataInicio: null,
      dataFim: null
    };

    // Limpar filtros FlaxFlow
    this.filtrosFlaxFlow = {
      nomeServidor: null,
      cpf: null
    };

    // Restaurar listas originais
    this.listaSimplificado = [...this.listaSimplificadoOriginal];
    this.listaUploadServidores = [...this.listaUploadServidoresOriginal];
    this.listaUploadAposentados = [...this.listaUploadAposentadosOriginal];
    this.listaUploadPensionistas = [...this.listaUploadPensionistasOriginal];
    this.listaUploadIdadeAposentadoria = [...this.listaUploadIdadeAposentadoriaOriginal];
    this.listaImportacaoMensal = [...this.listaImportacaoMensalOriginal];
    this.listaUploadServidoresCenso = [...this.listaUploadServidoresCensoOriginal];
    this.listaFlaxFlow = [...this.listaFlaxFlowOriginal];
    this.listaSalarioBase = [...this.listaSalarioBaseOriginal];

    // Resetar páginas para primeira página
    this.currentPageSimplificado = 1;
    this.currentPageServidores = 1;
    this.currentPageAposentados = 1;
    this.currentPagePensionistas = 1;
    this.currentPageIdadeAposentadoria = 1;
    this.currentPageMensal = 1;
    this.currentPageServidoresCenso = 1;
    this.currentPageFlaxFlow = 1;
    this.currentPageSalarioBase = 1;

    // Recarregar dados FlaxFlow se estiver na tab FlaxFlow
    if (this.idCidade) {
      this.carregarDadosFlaxFlow();
    }
  }

  // Métodos para aplicar filtros FlaxFlow
  aplicarFiltrosFlaxFlow() {
    this.currentPageFlaxFlow = 1;
    this.carregarDadosFlaxFlow();
  }

  limparFiltrosFlaxFlow() {
    this.filtrosFlaxFlow = {
      nomeServidor: null,
      cpf: null
    };
    this.currentPageFlaxFlow = 1;
    this.carregarDadosFlaxFlow();
  }

  private filtrarPorData(lista: any[]): any[] {
    return lista.filter(item => {
      if (!item.data_inclusao) return true;
      
      const dataItem = new Date(item.data_inclusao);
      let dataInicio = null;
      let dataFim = null;

      if (this.filters.dataInicio) {
        const partes = this.filters.dataInicio.split('/');
        if (partes.length === 3) {
          dataInicio = new Date(partes[2] + '-' + partes[1] + '-' + partes[0]);
        }
      }

      if (this.filters.dataFim) {
        const partes = this.filters.dataFim.split('/');
        if (partes.length === 3) {
          dataFim = new Date(partes[2] + '-' + partes[1] + '-' + partes[0]);
          dataFim.setHours(23, 59, 59, 999); // Final do dia
        }
      }

      if (dataInicio && dataFim) {
        return dataItem >= dataInicio && dataItem <= dataFim;
      } else if (dataInicio) {
        return dataItem >= dataInicio;
      } else if (dataFim) {
        return dataItem <= dataFim;
      }

      return true;
    });
  }

  private filtrarPorDataFlaxFlow(lista: any[]): any[] {
    return lista.filter(item => {
      if (!item.data_envio) return true;
      
      const dataItem = new Date(item.data_envio);
      let dataInicio = null;
      let dataFim = null;

      if (this.filters.dataInicio) {
        const partes = this.filters.dataInicio.split('/');
        if (partes.length === 3) {
          dataInicio = new Date(partes[2] + '-' + partes[1] + '-' + partes[0]);
        }
      }

      if (this.filters.dataFim) {
        const partes = this.filters.dataFim.split('/');
        if (partes.length === 3) {
          dataFim = new Date(partes[2] + '-' + partes[1] + '-' + partes[0]);
          dataFim.setHours(23, 59, 59, 999); // Final do dia
        }
      }

      if (dataInicio && dataFim) {
        return dataItem >= dataInicio && dataItem <= dataFim;
      } else if (dataInicio) {
        return dataItem >= dataInicio;
      } else if (dataFim) {
        return dataItem <= dataFim;
      }

      return true;
    });
  }

  // Métodos de paginação

  // Simplificado
  getPaginatedSimplificado() {
    const startIndex = (this.currentPageSimplificado - 1) * this.itemsPorPaginaSimplificado;
    const endIndex = startIndex + this.itemsPorPaginaSimplificado;
    return this.listaSimplificado.slice(startIndex, endIndex);
  }

  // Servidores
  getPaginatedServidores() {
    const startIndex = (this.currentPageServidores - 1) * this.itemsPorPaginaServidores;
    const endIndex = startIndex + this.itemsPorPaginaServidores;
    return this.listaUploadServidores.slice(startIndex, endIndex);
  }

  // Aposentados
  getPaginatedAposentados() {
    const startIndex = (this.currentPageAposentados - 1) * this.itemsPorPaginaAposentados;
    const endIndex = startIndex + this.itemsPorPaginaAposentados;
    return this.listaUploadAposentados.slice(startIndex, endIndex);
  }

  // Pensionistas
  getPaginatedPensionistas() {
    const startIndex = (this.currentPagePensionistas - 1) * this.itemsPorPaginaPensionistas;
    const endIndex = startIndex + this.itemsPorPaginaPensionistas;
    return this.listaUploadPensionistas.slice(startIndex, endIndex);
  }

  // Idade Aposentadoria
  getPaginatedIdadeAposentadoria() {
    const startIndex = (this.currentPageIdadeAposentadoria - 1) * this.itemsPorPaginaIdadeAposentadoria;
    const endIndex = startIndex + this.itemsPorPaginaIdadeAposentadoria;
    return this.listaUploadIdadeAposentadoria.slice(startIndex, endIndex);
  }

  // Mensal
  getPaginatedMensal() {
    const startIndex = (this.currentPageMensal - 1) * this.itemsPorPaginaMensal;
    const endIndex = startIndex + this.itemsPorPaginaMensal;
    return this.listaImportacaoMensal.slice(startIndex, endIndex);
  }

  // Servidores Censo
  getPaginatedServidoresCenso() {
    const startIndex = (this.currentPageServidoresCenso - 1) * this.itemsPorPaginaServidoresCenso;
    const endIndex = startIndex + this.itemsPorPaginaServidoresCenso;
    return this.listaUploadServidoresCenso.slice(startIndex, endIndex);
  }

  // FlaxFlow
  getPaginatedFlaxFlow() {
    // Garantir que retorna um array válido
    if (!this.listaFlaxFlow) {
      return [];
    }
    return this.listaFlaxFlow;
  }

  // Método para mudança global de itens por página
  onItemsPorPaginaGlobalChange() {
    this.itemsPorPaginaSimplificado = this.itemsPorPaginaGlobal;
    this.itemsPorPaginaServidores = this.itemsPorPaginaGlobal;
    this.itemsPorPaginaAposentados = this.itemsPorPaginaGlobal;
    this.itemsPorPaginaPensionistas = this.itemsPorPaginaGlobal;
    this.itemsPorPaginaIdadeAposentadoria = this.itemsPorPaginaGlobal;
    this.itemsPorPaginaMensal = this.itemsPorPaginaGlobal;
    this.itemsPorPaginaServidoresCenso = this.itemsPorPaginaGlobal;
    this.itemsPorPaginaFlaxFlow = this.itemsPorPaginaGlobal;
    this.itemsPorPaginaSalarioBase = this.itemsPorPaginaGlobal;

    // Resetar todas as páginas para primeira página
    this.currentPageSimplificado = 1;
    this.currentPageServidores = 1;
    this.currentPageAposentados = 1;
    this.currentPagePensionistas = 1;
    this.currentPageIdadeAposentadoria = 1;
    this.currentPageMensal = 1;
    this.currentPageServidoresCenso = 1;
    this.currentPageFlaxFlow = 1;
    this.currentPageSalarioBase = 1;
    
    // Recarregar dados FlaxFlow com novo limit
    if (this.idCidade) {
      this.carregarDadosFlaxFlow();
    }
  }

  // Métodos de ordenação
  sortTable(column: string, tab: string) {
    // Para FlaxFlow, usar ordenação da API com lógica diferente
    if (tab === 'flaxFlow') {
      if (this.sortColumns.flaxFlow === column) {
        // Se já está ordenando por esta coluna, alternar direção
        this.sortDirections.flaxFlow = this.sortDirections.flaxFlow === 'ASC' ? 'DESC' : 'ASC';
      } else {
        // Se é uma nova coluna, definir como ASC por padrão
        this.sortColumns.flaxFlow = column;
        this.sortDirections.flaxFlow = 'ASC';
      }
      this.carregarDadosFlaxFlow();
      return;
    }

    // Para outras tabs, usar ordenação local
    if (this.sortColumns[tab] === column) {
      this.sortDirections[tab] = this.sortDirections[tab] === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumns[tab] = column;
      this.sortDirections[tab] = 'asc';
    }

    // Aplicar ordenação na lista correspondente
    switch (tab) {
      case 'simplificado':
        this.listaSimplificado = this.sortList(this.listaSimplificado, column, this.sortDirections[tab]);
        break;
      case 'servidores':
        this.listaUploadServidores = this.sortList(this.listaUploadServidores, column, this.sortDirections[tab]);
        break;
      case 'aposentados':
        this.listaUploadAposentados = this.sortList(this.listaUploadAposentados, column, this.sortDirections[tab]);
        break;
      case 'pensionistas':
        this.listaUploadPensionistas = this.sortList(this.listaUploadPensionistas, column, this.sortDirections[tab]);
        break;
      case 'idadeAposentadoria':
        this.listaUploadIdadeAposentadoria = this.sortList(this.listaUploadIdadeAposentadoria, column, this.sortDirections[tab]);
        break;
      case 'mensal':
        this.listaImportacaoMensal = this.sortList(this.listaImportacaoMensal, column, this.sortDirections[tab]);
        break;
      case 'servidoresCenso':
        this.listaUploadServidoresCenso = this.sortList(this.listaUploadServidoresCenso, column, this.sortDirections[tab]);
        break;
      case 'salarioBase':
        this.listaSalarioBase = this.sortList(this.listaSalarioBase, column, this.sortDirections[tab]);
        break;
    }

    // Resetar para primeira página
    this.resetPageForTab(tab);
  }

  private sortList(list: any[], column: string, direction: string): any[] {
    return list.sort((a, b) => {
      let valueA = a[column];
      let valueB = b[column];

      // Tratar datas
      if (column === 'data_inclusao' || column === 'competencia') {
        valueA = new Date(valueA);
        valueB = new Date(valueB);
      }

      // Tratar números
      if (column === 'total_rows' || column === 'inserted_rows' || column === 'status') {
        valueA = Number(valueA) || 0;
        valueB = Number(valueB) || 0;
      }

      if (valueA < valueB) {
        return direction === 'asc' ? -1 : 1;
      }
      if (valueA > valueB) {
        return direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  private resetPageForTab(tab: string) {
    switch (tab) {
      case 'simplificado':
        this.currentPageSimplificado = 1;
        break;
      case 'servidores':
        this.currentPageServidores = 1;
        break;
      case 'aposentados':
        this.currentPageAposentados = 1;
        break;
      case 'pensionistas':
        this.currentPagePensionistas = 1;
        break;
      case 'idadeAposentadoria':
        this.currentPageIdadeAposentadoria = 1;
        break;
      case 'mensal':
        this.currentPageMensal = 1;
        break;
      case 'servidoresCenso':
        this.currentPageServidoresCenso = 1;
        break;
      case 'flaxFlow':
        this.currentPageFlaxFlow = 1;
        this.carregarDadosFlaxFlow();
        break;
      case 'salarioBase':
        this.currentPageSalarioBase = 1;
        break;
    }
  }

  getSortIcon(column: string, tab: string): string {
    if (this.sortColumns[tab] === column) {
      if (tab === 'flaxFlow') {
        return this.sortDirections[tab] === 'ASC' ? 'fa-caret-up' : 'fa-caret-down';
      }
      return this.sortDirections[tab] === 'asc' ? 'fa-caret-up' : 'fa-caret-down';
    }
    return '';
  }

  isColumnSorted(column: string, tab: string): boolean {
    if (tab === 'flaxFlow') {
      return this.sortColumns.flaxFlow === column;
    }
    return this.sortColumns[tab] === column;
  }

  getStatusColor(status: number): string {
    switch (status) {
      case 0:
        return '#6c757d'; // Cinza para na fila
      case 1:
        return '#ffc107'; // Amarelo para processando
      case 2:
        return '#28a745'; // Verde para processado
      case 3:
        return '#dc3545'; // Vermelho para erro
      default:
        return '#6c757d'; // Cinza para status desconhecido
    }
  }

  getFlaxFlowStatusColor(statusFlaxFlow: string): string {
    switch (statusFlaxFlow) {
      case 'PROCESSAMENTO_COMPLETO':
      case 'PROCESSADO':
        return '#398230'; // Verde
      case 'EM_PROCESSAMENTO':
      case 'PROCESSANDO':
      case 'ANEXADO':
        return '#008178'; // Teal
      case 'TEMPO_LIMITE_EXCEDIDO':
      case 'TEMPO LIMITE EXCEDIDO':
        return '#C83030'; // Vermelho
      case 'DESATIVADO':
      case 'CPF_NAO_ENCONTRADO':
        return '#707070'; // Cinza
      default:
        return '#707070'; // Cinza para status desconhecido
    }
  }

  getFlaxFlowStatusBackgroundColor(statusFlaxFlow: string): string {
    switch (statusFlaxFlow) {
      case 'PROCESSAMENTO_COMPLETO':
      case 'PROCESSADO':
        return '#d2f2cd'; // Verde claro
      case 'EM_PROCESSAMENTO':
      case 'PROCESSANDO':
      case 'ANEXADO':
        return '#d9f2f0'; // Azul/Teal claro
      case 'TEMPO_LIMITE_EXCEDIDO':
      case 'TEMPO LIMITE EXCEDIDO':
        return '#FAEBEB'; // Vermelho claro
      case 'DESATIVADO':
      case 'CPF_NAO_ENCONTRADO':
        return '#F2F2F2'; // Cinza claro
      default:
        return '#F2F2F2'; // Cinza claro para status desconhecido
    }
  }

  traduzirActionFlaxFlow(action: number | null): string {
    if (action === null || action === undefined) {
      return '-';
    }
    switch (action) {
      case 0:
        return 'Processar e Anexar';
      case 1:
        return 'Processar';
      case 2:
        return 'Anexar';
      default:
        return '-';
    }
  }

  traduzirStatusFlaxFlow(statusFlaxFlow: string): string {
    switch (statusFlaxFlow) {
      case 'PROCESSAMENTO_COMPLETO':
      case 'PROCESSADO':
        return 'PROCESSADO';
      case 'EM_PROCESSAMENTO':
      case 'PROCESSANDO':
        return 'EM PROCESSAMENTO';
      case 'ANEXADO':
        return 'ANEXADO';
      case 'TEMPO_LIMITE_EXCEDIDO':
      case 'TEMPO LIMITE EXCEDIDO':
        return 'TEMPO LIMITE EXCEDIDO';
      case 'DESATIVADO':
        return 'DESATIVADO';
      case 'CPF_NAO_ENCONTRADO':
        return 'CPF NÃO ENCONTRADO';
      default:
        return statusFlaxFlow || 'DESCONHECIDO';
    }
  }

  // Métodos auxiliares para debug
  hasSimplificadoData(): boolean {
    return this.listaSimplificado && this.listaSimplificado.length > 0;
  }

  hasServidoresData(): boolean {
    return this.listaUploadServidores && this.listaUploadServidores.length > 0;
  }

  hasAposentadosData(): boolean {
    return this.listaUploadAposentados && this.listaUploadAposentados.length > 0;
  }

  hasPensionistasData(): boolean {
    return this.listaUploadPensionistas && this.listaUploadPensionistas.length > 0;
  }

  hasIdadeAposentadoriaData(): boolean {
    return this.listaUploadIdadeAposentadoria && this.listaUploadIdadeAposentadoria.length > 0;
  }

  hasMensalData(): boolean {
    return this.listaImportacaoMensal && this.listaImportacaoMensal.length > 0;
  }

  hasServidoresCensoData(): boolean {
    return this.listaUploadServidoresCenso && this.listaUploadServidoresCenso.length > 0;
  }

  hasFlaxFlowData(): boolean {
    return this.listaFlaxFlow && this.listaFlaxFlow.length > 0;
  }

  hasSalarioBaseData(): boolean {
    return this.listaSalarioBase && this.listaSalarioBase.length > 0;
  }

  hasPendingSalarioBase(): boolean {
    return this.listaSalarioBase && this.listaSalarioBase.some(item => item.status === 0 || item.status === 1);
  }

  // Salário Base
  getPaginatedSalarioBase() {
    const startIndex = (this.currentPageSalarioBase - 1) * this.itemsPorPaginaSalarioBase;
    const endIndex = startIndex + this.itemsPorPaginaSalarioBase;
    return this.listaSalarioBase.slice(startIndex, endIndex);
  }

  // Método para forçar atualização da view
  forceUpdate() {
    this.changeDetectorRef.markForCheck();
    this.changeDetectorRef.detectChanges();
  }

  // Métodos para controle de progresso
  iniciarProgresso(tipoImportacao: string, totalLinhas: number) {
    this.progressoImportacao = {
      ativo: true,
      percentual: 0,
      linhasProcessadas: 0,
      totalLinhas: totalLinhas,
      mensagem: 'Iniciando importação...',
      tipoImportacao: tipoImportacao
    };
    this.changeDetectorRef.detectChanges();
  }

  atualizarProgresso(linhasProcessadas: number, mensagem: string) {
    this.progressoImportacao.linhasProcessadas = linhasProcessadas;
    this.progressoImportacao.percentual = Math.round((linhasProcessadas / this.progressoImportacao.totalLinhas) * 100);
    this.progressoImportacao.mensagem = mensagem;
    this.changeDetectorRef.detectChanges();
  }

  finalizarProgresso() {
    this.progressoImportacao.ativo = false;
    this.progressoImportacao.percentual = 100;
    this.progressoImportacao.mensagem = 'Importação concluída!';
    this.changeDetectorRef.detectChanges();
  }

  cancelarProgresso() {
    this.progressoImportacao.ativo = false;
    this.progressoImportacao.mensagem = 'Importação cancelada';
    this.changeDetectorRef.detectChanges();
  }

  // Método para calcular percentual de progresso baseado no status
  getProgressPercentage(importacao: any): number {
    if (!importacao || !importacao.total_rows) {
      return 0;
    }

    switch (importacao.status) {
      case 0: // na fila
        return 0;
      case 1: // processando
        const insertedRows = importacao.inserted_rows || 0;
        return Math.round((insertedRows / importacao.total_rows) * 100);
      case 2: // processado
        return 100;
      default:
        return 0;
    }
  }

  // Métodos para polling
  private hasImportingJobs(): boolean {
    return this.listaUploadServidoresCenso.some(item => item.status === 1);
  }

  private startPolling() {
    if (this.pollingInterval) {
      return; // Já está fazendo polling
    }

    this.pollingInterval = setInterval(() => {
      if (this.hasImportingJobs()) {
        this.refreshData();
      } else {
        this.stopPolling();
      }
    }, this.POLLING_INTERVAL);
  }

  private stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  }

  private async refreshData() {
    try {
      if (this.idCidade) {
        const planilhas = await this.apiCall
          .get("servidor/arquivo/planilha?id_cidade=" + this.idCidade)
          .pipe(take(1))
          .toPromise();

        if (planilhas && planilhas.length > 0) {
          this.listaUploadServidoresCenso = planilhas.filter(item => item.type === 99);
          this.listaUploadServidoresCensoOriginal = [...this.listaUploadServidoresCenso];
          this.changeDetectorRef.detectChanges();
        }
      }
    } catch (error) {
      console.error('Erro ao atualizar dados:', error);
    }
  }

  // ========== NOVOS MÉTODOS PARA MODAIS ==========

  // Método para resetar dados de upload
  resetUploadData() {
    this.uploadData = {
      file: null,
      month: '',
      year: '',
      loading: false,
      errors: {
        file: '',
        month: '',
        year: ''
      }
    };
  }

  // Método para validar arquivo selecionado
  validateFile(file: File, allowedExtensions: string[]): string {
    if (!file) {
      return 'Você deve selecionar um arquivo!';
    }

    const fileName = file.name.toLowerCase();
    const isValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
    
    if (!isValidExtension) {
      const extensionsText = allowedExtensions.join(', ');
      return `Apenas arquivos nos formatos ${extensionsText} são aceitos!`;
    }

    return '';
  }

  // Método chamado quando arquivo é selecionado
  onFileSelected(event: any) {
    const file = event.target.files?.[0];
    if (file) {
      this.uploadData.file = file;
      this.uploadData.errors.file = '';
    }
  }

  // Métodos para obter título e descrição dinâmicos
  getUploadTitle(): string {
    return this.currentUploadTitle;
  }

  getUploadDescription(): string {
    return this.currentUploadDescription;
  }

  // ========== NOVOS MÉTODOS DE UPLOAD COM MODAIS ==========

  // Novo método para Upload Simplificado
  async openUploadSimplificadoModal(content: any) {
    this.resetUploadData();
    const modal = this.modalService.open(content, { 
      centered: true, 
      size: "md",
      backdrop: 'static',
      keyboard: false
    });
  }

  async processarUploadSimplificado(modal: any) {
    this.uploadData.loading = true;
    this.uploadData.errors.file = this.validateFile(this.uploadData.file, ['.csv']);
    
    if (this.uploadData.errors.file) {
      this.uploadData.loading = false;
      return;
    }

    try {
      await this.processarUploadArquivo(
        this.uploadData.file,
        this.colunasEsperadasSimplificado,
        9,
        true
      );
      
      await this.app.alert(
        "Tudo certo!",
        "Planilha cadastrada com sucesso!",
        "success"
      );
      
      modal.close('success');
      await this.ngOnInit();
    } catch (error) {
      console.error('Erro no upload:', error);
      await this.app.alert(
        "Erro!",
        error.message || "Erro ao processar o arquivo!",
        "error"
      );
    } finally {
      this.uploadData.loading = false;
    }
  }

  // Novo método para Upload Idade Aposentadoria
  async openUploadIdadeAposentadoriaModal(content: any) {
    this.resetUploadData();
    const modal = this.modalService.open(content, { 
      centered: true, 
      size: "md",
      backdrop: 'static',
      keyboard: false
    });
  }

  async processarUploadIdadeAposentadoria(modal: any) {
    this.uploadData.loading = true;
    this.uploadData.errors.file = this.validateFile(this.uploadData.file, ['.csv']);
    
    if (this.uploadData.errors.file) {
      this.uploadData.loading = false;
      return;
    }

    try {
      await this.processarUploadArquivo(
        this.uploadData.file,
        this.colunasEsperadasIdadeAposentadoria,
        8,
        false
      );
      
      await this.app.alert(
        "Tudo certo!",
        "Planilha cadastrada com sucesso!",
        "success"
      );
      
      modal.close('success');
      await this.ngOnInit();
    } catch (error) {
      console.error('Erro no upload:', error);
      await this.app.alert(
        "Erro!",
        error.message || "Erro ao processar o arquivo!",
        "error"
      );
    } finally {
      this.uploadData.loading = false;
    }
  }

  // Novo método para Upload Geral (Servidores, Aposentados, Pensionistas)
  async openUploadGeralModal(content: any, type: number) {
    this.resetUploadData();
    this.currentUploadType = type;
    
    switch (type) {
      case 1:
        this.currentUploadTitle = "Upload Servidores";
        this.currentUploadDescription = "Selecione um arquivo CSV com dados dos servidores utilizando a base modelo da Secretaria da Previdência.";
        break;
      case 2:
        this.currentUploadTitle = "Upload Aposentados";
        this.currentUploadDescription = "Selecione um arquivo CSV com dados dos aposentados utilizando a base modelo da Secretaria da Previdência.";
        break;
      case 3:
        this.currentUploadTitle = "Upload Pensionistas";
        this.currentUploadDescription = "Selecione um arquivo CSV com dados dos pensionistas utilizando a base modelo da Secretaria da Previdência.";
        break;
    }
    
    const modal = this.modalService.open(content, { 
      centered: true, 
      size: "md",
      backdrop: 'static',
      keyboard: false
    });
  }

  async processarUploadGeral(modal: any) {
    this.uploadData.loading = true;
    this.uploadData.errors.file = this.validateFile(this.uploadData.file, ['.csv']);
    
    if (this.uploadData.errors.file) {
      this.uploadData.loading = false;
      return;
    }

    try {
      let expectedColumns = [];
      switch (this.currentUploadType) {
        case 1:
          expectedColumns = this.colunasEsperadasAtivos;
          break;
        case 2:
          expectedColumns = this.colunasEsperadasInativos;
          break;
        case 3:
          expectedColumns = this.colunasEsperadasAposentados;
          break;
      }

      await this.processarUploadArquivo(
        this.uploadData.file,
        expectedColumns,
        this.currentUploadType,
        false
      );
      
      await this.app.alert(
        "Tudo certo!",
        "Planilha cadastrada com sucesso!",
        "success"
      );
      
      modal.close('success');
      await this.ngOnInit();
    } catch (error) {
      console.error('Erro no upload:', error);
      await this.app.alert(
        "Erro!",
        error.message || "Erro ao processar o arquivo!",
        "error"
      );
    } finally {
      this.uploadData.loading = false;
    }
  }

  // Novo método para Upload Movimentação Mensal
  async openUploadMovimentacaoModal(content: any) {
    this.resetUploadData();
    const modal = this.modalService.open(content, { 
      centered: true, 
      size: "lg",
      backdrop: 'static',
      keyboard: false
    });
  }

  // Novo método para Upload Servidores Censo
  async openUploadServidoresCensoModal(content: any) {
    this.resetUploadData();
    const modal = this.modalService.open(content, { 
      centered: true, 
      size: "md",
      backdrop: 'static',
      keyboard: false
    });
  }

  async processarUploadMovimentacao(modal: any) {
    this.uploadData.loading = true;
    
    // Validações
    this.uploadData.errors.month = !this.uploadData.month ? 'Você deve selecionar um mês!' : '';
    this.uploadData.errors.year = !this.uploadData.year ? 'Você deve informar o ano!' : '';
    this.uploadData.errors.file = this.validateFile(this.uploadData.file, ['.xls', '.xlsx']);
    
    if (this.uploadData.errors.month || this.uploadData.errors.year || this.uploadData.errors.file) {
      this.uploadData.loading = false;
      return;
    }

    try {
      const formattedDate = moment(`${this.uploadData.year}-${this.uploadData.month}-01`).format("YYYY-MM-DD");
      await this.processarUploadMovimentacaoExcel(this.uploadData.file, formattedDate);
      
      await this.app.alert(
        "Tudo certo!",
        "Planilha cadastrada com sucesso!",
        "success"
      );
      
      modal.close('success');
      await this.ngOnInit();
    } catch (error) {
      console.error('Erro no upload:', error);
      await this.app.alert(
        "Erro!",
        error.message || "Erro ao processar o arquivo!",
        "error"
      );
    } finally {
      this.uploadData.loading = false;
    }
  }

  async processarUploadServidoresCenso(modal: any) {
    this.uploadData.loading = true;
    this.uploadData.errors.file = this.validateFile(this.uploadData.file, ['.xlsx', '.xls']);
    
    if (this.uploadData.errors.file) {
      this.uploadData.loading = false;
      return;
    }

    try {
      await this.processarUploadServidoresCensoArquivo(this.uploadData.file);
      
      await this.app.alert(
        "Tudo certo!",
        "Planilha cadastrada com sucesso! A importação será processada em background.",
        "success"
      );
      
      modal.close('success');
      await this.ngOnInit();
    } catch (error) {
      console.error('Erro no upload:', error);
      await this.app.alert(
        "Erro!",
        error.message || "Erro ao processar o arquivo!",
        "error"
      );
    } finally {
      this.uploadData.loading = false;
    }
  }

  // Método auxiliar para processar upload de arquivo CSV
  private async processarUploadArquivo(
    file: File,
    expectedColumns: string[],
    type: number,
    isSimplificado: boolean
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async () => {
        try {
          let text = reader.result as string;
          let csvJson = this.csvJSON(text);
          let lista = JSON.parse(csvJson);
          let newLista = [];
          
          for (let l of lista) {
            const trimmed = Object.entries(l).reduce((acc, curr) => {
              let [key, value] = curr;
              acc[typeof key === "string" ? key.trim() : key] = value;
              return acc;
            }, {});
            newLista.push(trimmed);
          }
          
          lista = [...newLista];
          let cols = lista ? Object.keys(lista[0]) : [];
          let totalCol = lista ? Object.keys(lista[0]).length : 0;
          let totalDeLinhas = lista.length;
          let tipo = file.type;

          // Validações
          if (totalCol != expectedColumns.length) {
            throw new Error("Quantidade de colunas do seu arquivo é diferente da esperada!");
          }

          const array2Sorted = expectedColumns.slice().sort();
          const isEqual =
            cols.length === expectedColumns.length &&
            cols
              .slice()
              .sort()
              .every(function (value, index) {
                return value === array2Sorted[index];
              });

          if (!isEqual) {
            throw new Error("O cabeçalho do seu arquivo é diferente do esperado!");
          }

          let ibgeFound = [];
          for (let l of lista) {
            if (l.CO_IBGE && !ibgeFound.find((i) => i == l.CO_IBGE)) {
              ibgeFound.push(l.CO_IBGE);
            }
          }

          if (ibgeFound.length !== 1) {
            throw new Error("O seu arquivo contém mais de um código IBGE!");
          }

          if (this.cidade && this.cidade.ibge && ibgeFound[0] != this.cidade.ibge) {
            throw new Error(
              "O seu arquivo contém código IBGE inválido! o código esperado para esta cidade é " +
              this.cidade.ibge
            );
          }

          // Upload do arquivo
          const uploadFiles = await this.apiCall
            .post("servidor/arquivo/exact/url", {
              extension: file.name,
              type: tipo,
            })
            .pipe(take(1))
            .toPromise();

          if (!uploadFiles || !uploadFiles.result) {
            throw new Error("Erro ao obter URL de upload");
          }

          var options = {
            headers: { "Content-Type": tipo, "x-amz-acl": "public-read" },
          };

          await this.http
            .put<any>(uploadFiles.result.replace(".sa-east-1", ""), file, options)
            .toPromise();

          let urlArquivo = uploadFiles.result.split("?")[0];

          await this.spinner.show(undefined, {
            type: "ball-triangle-path",
            size: "medium",
            bdColor: "rgba(0, 0, 0, 0.8)",
            color: "#fff",
            fullScreen: true,
          });

          await this.apiCall
            .post(
              `servidor/arquivo/planilha?tipo=${type}&cidade=${this.idCidade}&url=${urlArquivo}&total_rows=${totalDeLinhas}&simplificada=${isSimplificado}`
            )
            .pipe(take(1))
            .toPromise();

          await this.spinner.hide();
          resolve();
        } catch (error) {
          await this.spinner.hide();
          reject(error);
        }
      };

      reader.readAsText(file as Blob, "ISO-8859-1");
    });
  }

  // Método auxiliar para processar upload de movimentação Excel
  private async processarUploadMovimentacaoExcel(file: File, formattedDate: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const data = e.target?.result;
          if (!data) {
            throw new Error("O arquivo está vazio");
          }

          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
          let tipo = file.type;

          console.log("Registros", jsonData.length - 1);

          if (jsonData.length === 1) {
            throw new Error("O arquivo está vazio");
          }

          const headers = jsonData[0];
          if (
            headers[0] !== "Competência" ||
            headers[1] !== "Matrícula" ||
            headers[2] !== "CPF" ||
            headers[3] !== "Salário"
          ) {
            throw new Error("As colunas não têm os nomes corretos.");
          }

          const uploadFiles = await this.apiCall
            .post("servidor/arquivo/exact/url", {
              extension: file.name,
              type: tipo,
            })
            .pipe(take(1))
            .toPromise();

          if (!uploadFiles || !uploadFiles.result) {
            throw new Error("Erro ao obter URL de upload");
          }

          var options = {
            headers: { "Content-Type": tipo, "x-amz-acl": "public-read" },
          };

          await this.http
            .put<any>(uploadFiles.result.replace(".sa-east-1", ""), file, options)
            .toPromise();

          let urlArquivo = uploadFiles.result.split("?")[0];

          await this.spinner.show(undefined, {
            type: "ball-triangle-path",
            size: "medium",
            bdColor: "rgba(0, 0, 0, 0.8)",
            color: "#fff",
            fullScreen: true,
          });

          await this.apiCall
            .post(
              `servidor/arquivo/planilha?tipo=${77}&cidade=${this.idCidade}&url=${urlArquivo}&total_rows=${jsonData.length}&simplificada=false&competencia=${formattedDate}`
            )
            .pipe(take(1))
            .toPromise();

          await this.spinner.hide();
          resolve();
        } catch (error) {
          await this.spinner.hide();
          reject(error);
        }
      };

      reader.readAsArrayBuffer(file);
    });
  }

  // Método auxiliar para processar upload de servidores censo
  private async processarUploadServidoresCensoArquivo(file: File): Promise<void> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const data = e.target?.result;
          if (!data) {
            throw new Error("O arquivo está vazio");
          }

          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
          let tipo = file.type;

          console.log("Registros", jsonData.length - 1);

          if (jsonData.length === 1) {
            throw new Error("O arquivo está vazio");
          }

          const headers = jsonData[0] as string[];
          const lista = [];
          
          // Converter para formato de objeto
          for (let i = 1; i < jsonData.length; i++) {
            const row = jsonData[i] as any[];
            const obj: any = {};
            headers.forEach((header, index) => {
              obj[header] = row[index] || '';
            });
            lista.push(obj);
          }
          
          let cols = headers as string[];
          let totalCol = headers.length;
          let totalDeLinhas = lista.length;

          // Durante a transição, aceita também o layout anterior, que tinha
          // Estado/Cidade duplicados e não possuía Secretaria.
          const layoutLegado = this.colunasEsperadasServidoresCenso
            .map(coluna => coluna === 'Estado Naturalidade' ? 'Estado' : coluna)
            .map(coluna => coluna === 'Cidade Naturalidade' ? 'Cidade' : coluna)
            .filter(coluna => coluna !== 'Secretaria');
          const layoutsAceitos = [
            this.colunasEsperadasServidoresCenso,
            [...layoutLegado, 'Secretaria'],
            layoutLegado
          ];
          const isEqual = layoutsAceitos.some(layout => {
            if (cols.length !== layout.length) return false;
            const esperado = layout.slice().sort();
            return cols.slice().sort().every((value, index) => value === esperado[index]);
          });

          if (!isEqual) {
            throw new Error("O cabeçalho do seu arquivo é diferente do esperado!");
          }

          // Para servidores censo, não validamos IBGE pois não temos essa coluna
          // A validação será feita pelo backend

          // Upload do arquivo
          const uploadFiles = await this.apiCall
            .post("servidor/arquivo/exact/url", {
              extension: file.name,
              type: tipo,
            })
            .pipe(take(1))
            .toPromise();

          if (!uploadFiles || !uploadFiles.result) {
            throw new Error("Erro ao obter URL de upload");
          }

          var options = {
            headers: { "Content-Type": tipo, "x-amz-acl": "public-read" },
          };

          await this.http
            .put<any>(uploadFiles.result.replace(".sa-east-1", ""), file, options)
            .toPromise();

          let urlArquivo = uploadFiles.result.split("?")[0];

          await this.spinner.show(undefined, {
            type: "ball-triangle-path",
            size: "medium",
            bdColor: "rgba(0, 0, 0, 0.8)",
            color: "#fff",
            fullScreen: true,
          });

          // Chamar o endpoint específico para servidores censo
          await this.apiCall
            .post("planilhas", {
              url: urlArquivo,
              id_cidade: this.idCidade,
              type: 99, // Tipo fixo para importação de servidores censo
              total_rows: totalDeLinhas.toString()
            })
            .pipe(take(1))
            .toPromise();

          await this.spinner.hide();
          resolve();
        } catch (error) {
          await this.spinner.hide();
          reject(error);
        }
      };

      reader.readAsArrayBuffer(file);
    });
  }

  // Métodos para FlaxFlow
  async carregarDadosFlaxFlow() {
    if (!this.idCidade) {
      console.log('carregarDadosFlaxFlow: idCidade não definido');
      return;
    }

    this.flaxFlowLoading = true;
    
    await this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    try {
      const offset = (this.currentPageFlaxFlow - 1) * this.itemsPorPaginaFlaxFlow;
      const orderBy = this.sortColumns.flaxFlow || 'data_envio';
      const orderDirection = this.sortDirections.flaxFlow || 'DESC';

      let params = `id_cidade=${this.idCidade}&offset=${offset}&limit=${this.itemsPorPaginaFlaxFlow}&orderBy=${orderBy}&orderDirection=${orderDirection}`;

      // Adicionar filtros de nome do servidor e CPF
      // Verificar se o filtro existe, não é null, não é undefined e não é string vazia
      if (this.filtrosFlaxFlow.nomeServidor && 
          this.filtrosFlaxFlow.nomeServidor !== null && 
          this.filtrosFlaxFlow.nomeServidor !== undefined && 
          this.filtrosFlaxFlow.nomeServidor.trim() !== '') {
        params += `&nome_servidor=${encodeURIComponent(this.filtrosFlaxFlow.nomeServidor.trim())}`;
      }

      if (this.filtrosFlaxFlow.cpf && 
          this.filtrosFlaxFlow.cpf !== null && 
          this.filtrosFlaxFlow.cpf !== undefined && 
          this.filtrosFlaxFlow.cpf.trim() !== '') {
        // Remover formatação do CPF (pontos, traços e espaços)
        const cpfLimpo = this.filtrosFlaxFlow.cpf.trim().replace(/[.\-\s]/g, '');
        if (cpfLimpo.length > 0) {
          params += `&cpf=${encodeURIComponent(cpfLimpo)}`;
        }
      }

      console.log('Carregando dados FlaxFlow com params:', params);

      const response = await this.apiCall
        .get(`servidor/flaxflow/log/v2?${params}`)
        .pipe(take(1))
        .toPromise();

      console.log('Resposta FlaxFlow:', response);

      if (response && response.data && Array.isArray(response.data)) {
        // Criar uma nova referência do array para forçar detecção de mudanças
        this.listaFlaxFlow = Array.isArray(response.data) ? [...response.data] : [];
        this.listaFlaxFlowOriginal = [...this.listaFlaxFlow];
        
        if (response.pagination) {
          this.flaxFlowPagination = {
            total: response.pagination.total || 0,
            offset: response.pagination.offset || 0,
            limit: response.pagination.limit || 10,
            hasMore: response.pagination.hasMore || false
          };
        }

        console.log('Dados FlaxFlow carregados:', this.listaFlaxFlow.length, 'itens');
        console.log('Lista FlaxFlow completa:', JSON.stringify(this.listaFlaxFlow));
        console.log('Primeiro item:', this.listaFlaxFlow[0]);
        console.log('Tipo de listaFlaxFlow:', typeof this.listaFlaxFlow, Array.isArray(this.listaFlaxFlow));
        
        // Forçar detecção de mudanças imediatamente após atribuir os dados
        this.changeDetectorRef.markForCheck();
        this.changeDetectorRef.detectChanges();
      } else {
        console.log('Resposta vazia ou sem dados:', response);
        this.listaFlaxFlow = [];
        this.listaFlaxFlowOriginal = [];
        this.changeDetectorRef.markForCheck();
        this.changeDetectorRef.detectChanges();
      }
    } catch (error) {
      console.error('Erro ao carregar dados FlaxFlow:', error);
      this.listaFlaxFlow = [];
      this.listaFlaxFlowOriginal = [];
    } finally {
      await this.spinner.hide();
      this.flaxFlowLoading = false;
      
      // Sempre forçar detecção de mudanças após carregar dados
      setTimeout(() => {
        this.changeDetectorRef.markForCheck();
        this.changeDetectorRef.detectChanges();
        console.log('Detecção de mudanças forçada. Lista tem', this.listaFlaxFlow?.length || 0, 'itens');
      }, 50);
      
      // Se a tab já foi ativada, forçar novamente
      if (this.flaxFlowTabActivated) {
        setTimeout(() => {
          this.changeDetectorRef.markForCheck();
          this.changeDetectorRef.detectChanges();
        }, 200);
      }
    }
  }

  // Método para detectar quando a tab FlaxFlow é ativada
  onTabChange(event: NgbTabChangeEvent) {
    // Verificar se a tab FlaxFlow foi ativada
    // O nextId pode ser um número (índice) ou string (ID)
    const nextId = event.nextId;
    
    // FlaxFlow é a última tab (índice 7, começando do 0)
    // Vamos verificar se é a tab FlaxFlow de várias formas
    const isFlaxFlowTab = 
      (typeof nextId === 'number' && nextId === 7) ||
      (typeof nextId === 'string' && nextId.toLowerCase().includes('flaxflow')) ||
      (nextId && nextId.toString() === '7');
    
    if (isFlaxFlowTab) {
      console.log('Tab FlaxFlow ativada');
      this.flaxFlowTabActivated = true;
      
      // Forçar detecção de mudanças para garantir que a view seja atualizada
      // Usar múltiplos timeouts para garantir que a view seja renderizada
      setTimeout(() => {
        this.changeDetectorRef.markForCheck();
        this.changeDetectorRef.detectChanges();
      }, 0);
      
      setTimeout(() => {
        this.changeDetectorRef.markForCheck();
        this.changeDetectorRef.detectChanges();
      }, 100);
      
      setTimeout(() => {
        this.changeDetectorRef.markForCheck();
        this.changeDetectorRef.detectChanges();
      }, 300);
    }
  }

  onFlaxFlowPageChange(page: number) {
    this.currentPageFlaxFlow = page;
    this.carregarDadosFlaxFlow();
  }

  getTotalPagesFlaxFlow(): number {
    return Math.ceil(this.flaxFlowPagination.total / this.itemsPorPaginaFlaxFlow);
  }

  getFlaxFlowJsonUrl(item: any): string {
    if (!item.resultado_flaxflow_json) return null;
    // Assumindo que o resultado_flaxflow_json contém o nome do arquivo
    // Você pode precisar ajustar isso baseado na estrutura real da URL
    const baseUrl = item.chave ? item.chave.split('/').slice(0, -1).join('/') : '';
    return baseUrl ? `${baseUrl}/${item.resultado_flaxflow_json}` : null;
  }

  podeBaixarProcessado(item: any): boolean {
    return item.resultado_flaxflow_json && 
           item.statusflaxflow !== 'ANEXADO' && 
           item.statusflaxflow !== 'EM_PROCESSAMENTO' && 
           item.statusflaxflow !== 'PROCESSANDO';
  }

  visualizarJson(item: any) {
    this.router.navigate(['/page/flaxflow-json'], { 
      queryParams: { 
        idFlaxFlow: item.id,
        idCidade: this.idCidade
      } 
    });
  }

  abrirChaveExterna(item: any) {
    if (item.chave) {
      window.open(item.chave, '_blank');
    }
  }

  // Verificar se resultado_flaxflow_json é um link (começa com https)
  isLink(jsonString: string): boolean {
    if (!jsonString || typeof jsonString !== 'string') {
      return false;
    }
    
    const trimmed = jsonString.trim();
    return trimmed.toLowerCase().startsWith('https://') || trimmed.toLowerCase().startsWith('http://');
  }

  // Verificar se resultado_flaxflow_json é um JSON válido
  isJsonValid(jsonString: string): boolean {
    if (!jsonString || typeof jsonString !== 'string') {
      return false;
    }
    
    const trimmed = jsonString.trim();
    // Verificar se começa com { ou [ (indicando JSON)
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
      try {
        JSON.parse(trimmed);
        return true;
      } catch (e) {
        return false;
      }
    }
    
    return false;
  }

  getJsonButtonIcon(item: any): string {
    // Verificar se resultado_flaxflow_json é um JSON válido
    if (item.resultado_flaxflow_json && this.isJsonValid(item.resultado_flaxflow_json)) {
      return 'fa-eye';
    }
    // Se não for JSON, é um link/nome de arquivo, mostrar ícone de upload
    return 'fa-upload';
  }

  getJsonButtonTitle(item: any): string {
    // Verificar se resultado_flaxflow_json é um JSON válido
    if (item.resultado_flaxflow_json && this.isJsonValid(item.resultado_flaxflow_json)) {
      return 'Visualizar JSON';
    }
    // Se for um link (começa com https), informar que não é JSON
    if (item.resultado_flaxflow_json && this.isLink(item.resultado_flaxflow_json)) {
      return 'Este arquivo não é um JSON';
    }
    // Se não for JSON, é um link/nome de arquivo
    return 'Abrir arquivo externo';
  }

  // Verificar se o botão JSON deve estar desabilitado
  isJsonButtonDisabled(item: any): boolean {
    // Desabilitar se for um link (começa com https)
    return item.resultado_flaxflow_json && this.isLink(item.resultado_flaxflow_json);
  }

  handleJsonClick(item: any) {
    // Verificar se resultado_flaxflow_json é um JSON válido
    if (item.resultado_flaxflow_json && this.isJsonValid(item.resultado_flaxflow_json)) {
      // Se for JSON, abrir visualizador
      this.visualizarJson(item);
    } else {
      // Se não for JSON, abrir link externo (chave)
      this.abrirChaveExterna(item);
    }
  }

  enviarJson(item: any) {
    // Implementar envio do JSON
    console.log('Enviar JSON:', item);
  }

  atualizarJson(item: any) {
    // Implementar atualização do JSON
    console.log('Atualizar JSON:', item);
  }

  // Métodos para Upload FlaxFlow
  openModalFlaxFlow(content: any) {
    this.anexoFlaxFlow = {
      arquivos: [],
      opcao: "processarEAnexar"
    };
    this.statusEnvioFlaxFlow = '';
    this.modalService.open(content, { centered: true });
  }

  closeModalFlaxFlow(modal: any) {
    this.anexoFlaxFlow = {
      arquivos: [],
      opcao: "processarEAnexar"
    };
    this.statusEnvioFlaxFlow = '';
    modal.close('Close click');
  }

  async selecionaArquivoFlaxFlow(event: Event) {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    const arquivosSelecionados = Array.from(input.files);
    const arquivosValidos: File[] = [];

    for (const file of arquivosSelecionados) {
      arquivosValidos.push(file);
    }

    if (arquivosValidos.length > 0) {
      this.anexoFlaxFlow.arquivos = arquivosValidos;
    } else {
      this.anexoFlaxFlow.arquivos = [];
      input.value = ""; // limpa o input, já que nenhum arquivo é válido
    }
  }

  fileNameAndExtFlaxFlow(str: string) {
    var file = str.split("/").pop();
    return [
      file.substr(0, file.lastIndexOf(".")),
      file.substr(file.lastIndexOf(".") + 1, file.length),
    ];
  }

  async postFileFlaxFlow(extension: string, type: string) {
    const response = await this.apiCall
      .post(`servidor/arquivo/url`, { extension: extension, type: type })
      .pipe(take(1))
      .toPromise();
    if (response.result) {
      return response.result;
    } else {
      return null;
    }
  }

  mapActionFlaxFlow(opcao: string) {
    switch(opcao) {
      case "processar":
        return 1;
      case "anexar":
        return 2;
      default:
        return 0;
    }
  }

  async cadastrarAnexoFlaxFlow(modal: any) {
    const self = this;

    if (!self.anexoFlaxFlow.arquivos || self.anexoFlaxFlow.arquivos.length === 0) {
      return;
    }

    await self.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });

    try {
      for (let i = 0; i < self.anexoFlaxFlow.arquivos.length; i++) {
        const file = self.anexoFlaxFlow.arquivos[i];
        
        self.statusEnvioFlaxFlow = `Enviando (${i + 1}/${self.anexoFlaxFlow.arquivos.length}): ${file.name}`;

        // Verificar se o arquivo tem extensão
        if (file && self.fileNameAndExtFlaxFlow(file.name)[1]) {
          try {
            const urlToPostFile = await self.postFileFlaxFlow(
              self.fileNameAndExtFlaxFlow(file.name)[1],
              file.type
            );

            if (!urlToPostFile) {
              console.error(`Falha ao obter URL para upload do arquivo: ${file.name}`);
              continue;
            }

            var optionsFile = {
              headers: { "Content-Type": file.type, "x-amz-acl": "public-read" },
            };

            const uploadFile = await self.http
              .put(urlToPostFile, file, optionsFile)
              .toPromise();

            const locationFile = urlToPostFile.toString().split("?", 1)[0];
            const idaction = this.mapActionFlaxFlow(this.anexoFlaxFlow.opcao);

            if (locationFile) {
              const result = await self.apiCall
                .post(`servidor/flaxflow/createFile?key=${locationFile}&idcidade=${this.idCidade}&idaction=${idaction}&nameFile=${file.name}`)
                .pipe(take(1))
                .toPromise();
              
              console.log(`Arquivo ${file.name} enviado com sucesso:`, locationFile);

              // Enviar para FlaxFlow
              if (idaction === 2) {
                continue; // Pula o envio para FlaxFlow se a ação for apenas anexar
              }
              try {
                // Converter arquivo para base64 de forma compatível com browser
                const base64Content = await this.fileToBase64FlaxFlow(file);
                const idfile = result.idfile;
                
                // Obter token da FlaxFlow
                const flaxflowToken = await self.apiCall
                  .get(`servidor/flaxflow/gettokenflaxflow`)
                  .pipe(take(1))
                  .toPromise();

                const uploadData = {
                  file: locationFile,
                  idfile: idfile,
                  token: flaxflowToken.token,
                  fileName: file.name,
                  fileSize: file.size
                };

                const resultSendFile = await self.apiCall
                  .post(`servidor/flaxflow/uploadfile`, uploadData)
                  .pipe(take(1))
                  .toPromise();

                console.log(`Arquivo enviado para FlaxFlow: ${file.name}`, resultSendFile.result);

              } catch (flaxflowError) {
                console.error(`Erro ao enviar para FlaxFlow: ${file.name}`, flaxflowError);
              }
            }
          } catch (e) {
            console.error(`Erro ao enviar arquivo ${file.name}:`, e);
            await self.app.alert(
              `Erro`,
              `Falha ao enviar o arquivo "${file.name}".`,
              `error`
            );
          }
        }
      }

      await self.app.alert(`Sucesso`, `Todos os arquivos foram integrados com o FlaxFlow!`, `success`);
      modal.close("Close click");
      self.statusEnvioFlaxFlow = '';
      await self.carregarDadosFlaxFlow();
    } catch (error) {
      console.error("Erro ao enviar arquivos", error);
      await self.app.alert(`Erro`, `Ocorreu um erro ao enviar os arquivos.`, `error`);
    } finally {
      await self.spinner.hide();
    }
  }

  private async fileToBase64FlaxFlow(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  }

  // ========== MÉTODOS PARA SALÁRIO BASE ==========

  // Abrir modal de upload Salário Base
  async openUploadSalarioBaseModal(content: any) {
    this.resetUploadData();
    const modal = this.modalService.open(content, { 
      centered: true, 
      size: "lg",
      backdrop: 'static',
      keyboard: false
    });
  }

  // Processar upload de Salário Base
  async processarUploadSalarioBase(modal: any) {
    this.uploadData.loading = true;
    
    // Validações
    this.uploadData.errors.file = this.validateFile(this.uploadData.file, ['.csv', '.xls', '.xlsx']);
    
    if (this.uploadData.errors.file) {
      this.uploadData.loading = false;
      return;
    }

    try {
      const file = this.uploadData.file;
      const fileName = file.name.toLowerCase();
      
      // Determinar tipo de arquivo
      const isCSV = fileName.endsWith('.csv');
      const isExcel = fileName.endsWith('.xls') || fileName.endsWith('.xlsx');
      
      let totalRows = 0;
      
      // Contar linhas do arquivo
      if (isCSV) {
        totalRows = await this.contarLinhasCSV(file);
      } else if (isExcel) {
        totalRows = await this.contarLinhasExcel(file);
      }

      // Upload do arquivo para S3
      const tipo = file.type || (isCSV ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      
      const uploadFiles = await this.apiCall
        .post("servidor/arquivo/exact/url", {
          extension: file.name,
          type: tipo,
        })
        .pipe(take(1))
        .toPromise();

      if (!uploadFiles || !uploadFiles.result) {
        throw new Error("Erro ao obter URL de upload");
      }

      var options = {
        headers: { "Content-Type": tipo, "x-amz-acl": "public-read" },
      };

      await this.http
        .put<any>(uploadFiles.result.replace(".sa-east-1", ""), file, options)
        .toPromise();

      let urlArquivo = uploadFiles.result.split("?")[0];

      await this.spinner.show(undefined, {
        type: "ball-triangle-path",
        size: "medium",
        bdColor: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        fullScreen: true,
      });

      // Criar registro da planilha via endpoint específico
      const responseCriar = await this.apiCall
        .post("planilhas/salarios", {
          url: urlArquivo,
          id_cidade: this.idCidade,
          total_rows: totalRows
        })
        .pipe(take(1))
        .toPromise();

      if (!responseCriar || !responseCriar.id) {
        throw new Error("Erro ao criar registro da planilha");
      }

      await this.spinner.hide();
      
      await this.app.alert(
        "Tudo certo!",
        "Planilha de salários cadastrada com sucesso! O processamento será iniciado automaticamente em até 5 minutos e você pode acompanhar o status na lista.",
        "success"
      );
      
      modal.close('success');
      await this.ngOnInit();
      
      // Iniciar polling para atualizar o status
      this.startPollingSalarioBase();
      
    } catch (error) {
      await this.spinner.hide();
      console.error('Erro no upload de salário base:', error);
      await this.app.alert(
        "Erro!",
        error.message || "Erro ao processar o arquivo!",
        "error"
      );
    } finally {
      this.uploadData.loading = false;
    }
  }

  // Contar linhas de arquivo CSV
  private async contarLinhasCSV(file: File): Promise<number> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const text = reader.result as string;
        const lines = text.split(/\r?\n/).filter(line => line.trim() !== '');
        // Subtrair 1 para não contar o cabeçalho
        resolve(Math.max(0, lines.length - 1));
      };
      reader.onerror = () => reject(new Error('Erro ao ler arquivo CSV'));
      reader.readAsText(file, 'UTF-8');
    });
  }

  // Contar linhas de arquivo Excel
  private async contarLinhasExcel(file: File): Promise<number> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = e.target?.result;
          if (!data) {
            resolve(0);
            return;
          }
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
          // Subtrair 1 para não contar o cabeçalho.
          resolve(Math.max(0, jsonData.length - 1));
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = () => reject(new Error('Erro ao ler arquivo Excel'));
      reader.readAsArrayBuffer(file);
    });
  }

  // Iniciar polling para atualizar status das planilhas de salário base
  private startPollingSalarioBase() {
    if (this.pollingIntervalSalarioBase) {
      return; // Já está fazendo polling
    }

    this.pollingIntervalSalarioBase = setInterval(async () => {
      const hasPendingOrProcessing = this.listaSalarioBase.some(item => item.status === 0 || item.status === 1);
      if (hasPendingOrProcessing) {
        await this.refreshSalarioBaseData();
      } else {
        this.stopPollingSalarioBase();
      }
    }, 5000); // Verificar a cada 5 segundos
  }

  // Parar polling
  private stopPollingSalarioBase() {
    if (this.pollingIntervalSalarioBase) {
      clearInterval(this.pollingIntervalSalarioBase);
      this.pollingIntervalSalarioBase = null;
    }
  }

  // Atualizar dados de salário base
  private async refreshSalarioBaseData() {
    try {
      if (this.idCidade) {
        const planilhas = await this.apiCall
          .get("servidor/arquivo/planilha?id_cidade=" + this.idCidade)
          .pipe(take(1))
          .toPromise();

        if (planilhas && planilhas.length > 0) {
          this.listaSalarioBase = planilhas.filter(item => item.type === 100);
          this.listaSalarioBaseOriginal = [...this.listaSalarioBase];
          this.changeDetectorRef.detectChanges();
        }
      }
    } catch (error) {
      console.error('Erro ao atualizar dados de salário base:', error);
    }
  }

  // Traduzir status da planilha de salário base
  traduzirStatusSalarioBase(status: number): string {
    switch (status) {
      case 0:
        return "Pendente";
      case 1:
        return "Processando";
      case 2:
        return "Concluído";
      case 3:
        return "Erro";
      default:
        return "Desconhecido";
    }
  }

  // Obter cor do status de salário base
  getStatusColorSalarioBase(status: number): string {
    switch (status) {
      case 0:
        return '#6c757d'; // Cinza para pendente
      case 1:
        return '#ffc107'; // Amarelo para processando
      case 2:
        return '#28a745'; // Verde para concluído
      case 3:
        return '#dc3545'; // Vermelho para erro
      default:
        return '#6c757d';
    }
  }

  // Abrir modal de log de salário base
  async abrirLogSalarioBase(importacao: any, content: any) {
    this.salarioBaseLoading = true;
    this.logSalarioBase = null;

    try {
      const response = await this.apiCall
        .get(`planilhas/salarios/${importacao.id}/log`)
        .pipe(take(1))
        .toPromise();

      this.logSalarioBase = response;
      this.salarioBaseLoading = false;

      this.modalService.open(content, { 
        centered: true, 
        size: "xl",
        backdrop: 'static',
        keyboard: false
      });
    } catch (error) {
      this.salarioBaseLoading = false;
      console.error('Erro ao carregar log:', error);
      await this.app.alert(
        "Erro!",
        "Não foi possível carregar o log de processamento.",
        "error"
      );
    }
  }

  // Verificar se pode visualizar o log (status 2 ou 3)
  podeVisualizarLog(importacao: any): boolean {
    return importacao.status === 2 || importacao.status === 3;
  }

  // Formatar competência para exibição
  formatarCompetenciaSalarioBase(competencia: string): string {
    if (!competencia) return '---';
    
    // Se vier no formato "2024-01", converter para "01/2024"
    if (competencia.includes('-')) {
      const partes = competencia.split('-');
      if (partes.length >= 2) {
        return `${partes[1]}/${partes[0]}`;
      }
    }
    
    return competencia;
  }

  // Formatar CPF para exibição
  formatarCpf(cpf: string): string {
    if (!cpf) return '---';
    
    // Remover formatação existente
    const cpfLimpo = cpf.replace(/\D/g, '');
    
    // Aplicar máscara
    if (cpfLimpo.length === 11) {
      return cpfLimpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    
    return cpf;
  }
}
